import { camelizeKeys } from 'humps';
import { api } from '@dom/utils';

import { reduxDB } from '../redux';

const fetchGuideAlbum = async (id, guideData) => {
  try {
    const { data } = await api.get(`users/${id}/cover_image`);
    const { images } = camelizeKeys(data);
    reduxDB.guides.replace({
      ...guideData,
      album: images,
    });
  } catch (e) {
    // Handle error.
    console.log(e);
  };
};

export default fetchGuideAlbum;
